const getParamsFromUrlHash = (param = false) => {
    if (window.location.hash) {
        let payload = window.location.hash.substring(2, window.location.hash.length);
        let searchParams = new URLSearchParams(payload);

        if (param) {
            let selected = searchParams.get('services') || [];
            if (typeof selected === 'string') {
                selected = selected.split(',');
                selected = stringsToNumbers(selected);
            }
            return selected;
        }

        const result = {};
        searchParams.forEach((value, key) => {
            if (typeof value === 'string' && value !== '') {
                if (value.includes(',')) value = value.split(',');
                value = stringsToNumbers(value);
                result[key] = value;
            }
        });
        return result;
    }
    return [];
};

function stringsToNumbers(value) {
    if (!value) return null;
    if (typeof value === 'string') {
        return isNaN(value) ? value : Number(value);
    }
    return _.map(value, entry => {
        return isNaN(entry) ? entry : Number(entry);
    });
}

export default getParamsFromUrlHash;
